import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  mediumDate: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    '&:hover': {
      borderBottom: '2px solid rgba(0, 0, 0, 0.87)'
    },
    '&:active': {
      borderBottom: '2px solid #3f51b5'
    },
  },
  label: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '43px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  inputDate: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '34px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  inputCurrency: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '43px',
    paddingTop: '4px',
    paddingBottom: '7px',
    paddingLeft: '1%',
    paddingRight: '10px',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
    width: '100%',
  },
  inputText: {
    textTransform: 'uppercase',
  },
  porcentage: {
    paddingBottom: '4px',
    paddingRight: '5px',
    paddingLeft: '5px',
    flex: 1,
    justifyContent: 'end',
    alignItems: 'center',
    display: 'flex',
  },
  dateInputContainer: {
    display: 'flex',
    width: '90%',
    alignItems: 'center',
    justifyContent: 'center',
    height: '43px',
  }
}));
